import { useSyncExternalStore } from "react";

const locks = new Set<symbol>();
const listeners = new Set<() => void>();

function notify() {
    for (const listener of listeners) listener();
}

export function requestBottomNavSuppression(): () => void {
    const lock = Symbol("bottom-nav-suppression");
    locks.add(lock);
    notify();
    return () => {
        if (locks.delete(lock)) notify();
    };
}

export function subscribeBottomNavSuppression(listener: () => void) {
    listeners.add(listener);
    return () => {
        listeners.delete(listener);
    };
}

export function isBottomNavSuppressed() {
    return locks.size > 0;
}

export function useBottomNavSuppressed() {
    return useSyncExternalStore(
        subscribeBottomNavSuppression,
        isBottomNavSuppressed,
        () => false,
    );
}
